// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"85f3482b","129":"da111878","327":"8b62c314","399":"90d610b9","444":"d0f229a1","544":"ec676667","649":"a5d99bc0","940":"253370c8"}[chunkId] + ".chunk.js";
};